import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { SnackbarProvider } from 'notistack';
import infoFill from '@iconify/icons-eva/info-fill';
import alertCircleFill from '@iconify/icons-eva/alert-circle-fill';
import alertTriangleFill from '@iconify/icons-eva/alert-triangle-fill';
import checkmarkCircle2Fill from '@iconify/icons-eva/checkmark-circle-2-fill';
import { alpha, makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
const useStyles = makeStyles((theme) => {
    const isLight = theme.palette.mode === 'light';
    const createStyle = {
        color: `${theme.palette.text.primary} !important`,
        backgroundColor: `${theme.palette.background.paper} !important`,
    };
    return {
        containerRoot: {
            '& .MuiCollapse-wrapperInner': {
                width: '100%',
            },
        },
        contentRoot: {
            width: '100%',
            padding: theme.spacing(1.5),
            boxShadow: theme.customShadows.z8,
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.grey[isLight ? 0 : 800],
            backgroundColor: theme.palette.grey[isLight ? 900 : 0],
        },
        message: {
            padding: 0,
            fontWeight: theme.typography.fontWeightMedium,
        },
        action: {
            marginRight: -4,
            '& svg': {
                width: 20,
                height: 20,
                opacity: 0.48,
                '&:hover': { opacity: 1 },
            },
        },
        variantInfo: { ...createStyle },
        variantSuccess: { ...createStyle },
        variantWarning: { ...createStyle },
        variantError: { ...createStyle },
    };
});
function SnackbarIcon({ icon, color }) {
    return (_jsx(Box, Object.assign({ component: "span", sx: {
            mr: 1.5,
            width: 40,
            height: 40,
            display: 'flex',
            borderRadius: 1.5,
            alignItems: 'center',
            justifyContent: 'center',
            color: `${color}.main`,
            bgcolor: (theme) => alpha(theme.palette[color].main, 0.16),
        } }, { children: _jsx(Icon, { icon: icon, width: 24, height: 24 }, void 0) }), void 0));
}
export function NotistackProvider({ children }) {
    const classes = useStyles();
    return (_jsx(SnackbarProvider, Object.assign({ dense: true, maxSnack: 5, preventDuplicate: true, autoHideDuration: 3000, anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, iconVariant: {
            success: _jsx(SnackbarIcon, { icon: checkmarkCircle2Fill, color: "success" }, void 0),
            error: _jsx(SnackbarIcon, { icon: infoFill, color: "error" }, void 0),
            warning: _jsx(SnackbarIcon, { icon: alertTriangleFill, color: "warning" }, void 0),
            info: _jsx(SnackbarIcon, { icon: alertCircleFill, color: "info" }, void 0),
        }, classes: classes }, { children: children }), void 0));
}
//# sourceMappingURL=NotistackProvider.js.map